import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.object.assign";
import "core-js/modules/es.object.get-prototype-of";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.reflect.construct";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import * as React from 'react';
import classNames from 'classnames';
import { AlignBox } from "../Align";
import Box from "../Box";
import { ButtonBarContext } from "./ButtonBar";
import { UnstyledLink } from "../UnstyledLink";
import Icon from "../Icon/Icon";
import { PressableButton, PressableContext } from "../Pressable";
import SocialIcon from "../SocialIcon";
import Spinner from "../Spinner";
import { Text } from "../Text";
import FocusHandler from "../handler/FocusHandler";
import HoverHandler from "../handler/HoverHandler";

var getIconPadding = function getIconPadding(iconPosition, isLabelVisible, sizeValue) {
  if (!isLabelVisible && sizeValue === 'small') {
    return {
      horizontal: 2
    };
  } else if (!isLabelVisible && sizeValue === 'jumbo') {
    return {
      horizontal: 4
    };
  } else if (!isLabelVisible) {
    return {
      horizontal: 4
    };
  }

  return iconPosition === 'right' ? {
    left: 8
  } : {
    right: 8
  };
};

var getSpinnerColor = function getSpinnerColor(color) {
  return color === 'white' || color === 'base' ? 'white' : 'regular';
};

export var getPressableColor = function getPressableColor(color) {
  if (color === 'primary' || color === 'blue') {
    return 'primary';
  } else if (color === 'negative' || color === 'red') {
    return 'negative';
  } else if (color === 'base' || color === 'white') {
    return 'base';
  }

  return color == null ? 'base' : color;
};

var Button = /*#__PURE__*/function (_React$Component) {
  _inherits(Button, _React$Component);

  var _super = _createSuper(Button);

  function Button() {
    var _this;

    _classCallCheck(this, Button);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.node = void 0;

    _this.buttonRef = function (node) {
      _this.node = node;
    };

    return _this;
  }

  _createClass(Button, [{
    key: "focus",
    value: function focus() {
      if (this.node) {
        this.node.focus();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return /*#__PURE__*/React.createElement(ButtonBarContext.Consumer, null, function (context) {
        var _this2$props = _this2.props,
            alignContents = _this2$props.alignContents,
            className = _this2$props.className,
            color = _this2$props.color,
            disabled = _this2$props.disabled,
            disabledWhenPending = _this2$props.disabledWhenPending,
            ghost = _this2$props.ghost,
            hideLabel = _this2$props.hideLabel,
            href = _this2$props.href,
            icon = _this2$props.icon,
            iconPosition = _this2$props.iconPosition,
            invalid = _this2$props.invalid,
            label = _this2$props.label,
            pending = _this2$props.pending,
            radius = _this2$props.radius,
            size = _this2$props.size,
            type = _this2$props.type,
            width = _this2$props.width,
            remaining = _objectWithoutProperties(_this2$props, ["alignContents", "className", "color", "disabled", "disabledWhenPending", "ghost", "hideLabel", "href", "icon", "iconPosition", "invalid", "label", "pending", "radius", "size", "type", "width"]);

        var isDisabled = disabled || pending && disabledWhenPending;
        var isLabelVisible = !!label && !hideLabel;
        var disabledValue = context && context.disabled || isDisabled;
        var radiusValue = context && context.radius || radius;
        var sizeValue = context && context.size || size;
        var classes = classNames('Button', {
          'Button--color--blue': color === 'primary' || color === 'blue',
          'Button--color--red': color === 'negative' || color === 'red',
          'Button--color--white': color === 'base' || color === 'white',
          'Button--hideLabel': hideLabel
        }, context.className, className, {
          'Is--disabled': disabledValue
        });
        return /*#__PURE__*/React.createElement(FocusHandler, null, function (focusProps, inputMethod) {
          var isFocused = inputMethod !== null;
          return /*#__PURE__*/React.createElement(HoverHandler, null, function (hoverProps, isHovering) {
            return /*#__PURE__*/React.createElement(PressableButton, _extends({}, focusProps, hoverProps, {
              className: classes,
              color: getPressableColor(color),
              disabled: disabledValue,
              hovered: isHovering,
              focused: isFocused,
              ghost: ghost,
              radius: radiusValue,
              size: sizeValue,
              width: width
            }), /*#__PURE__*/React.createElement(PressableContext.Consumer, null, function (_ref) {
              var pressableContextClasses = _ref.pressableContextClasses,
                  color = _ref.color,
                  fontLineHeight = _ref.fontLineHeight,
                  fontSize = _ref.fontSize,
                  fontWeight = _ref.fontWeight,
                  padding = _ref.padding,
                  style = _ref.style,
                  width = _ref.width;
              var elementClasses = classNames('Button-element', pressableContextClasses);
              var labelProps = {
                lineHeight: fontLineHeight,
                size: fontSize,
                weight: fontWeight
              };
              return /*#__PURE__*/React.createElement(UnstyledLink, _extends({}, remaining, {
                className: elementClasses,
                disabled: disabledValue,
                href: !disabledValue ? href : undefined,
                ref: _this2.buttonRef,
                type: type,
                style: style
              }), /*#__PURE__*/React.createElement(AlignBox, {
                className: "Button-align",
                justifyContent: "center",
                reference: alignContents ? labelProps : undefined,
                reverse: iconPosition === 'right',
                innerStyle: {
                  width: '100%'
                }
              }, icon && !pending && /*#__PURE__*/React.createElement(Box, {
                padding: getIconPadding(iconPosition, isLabelVisible, sizeValue)
              }, icon === 'facebook' || icon === 'google' || icon === 'linkedin' || icon.category === 'social' ? /*#__PURE__*/React.createElement(SocialIcon, {
                className: "Button-icon",
                icon:
                /* $FlowFixMe this is correct */
                icon,
                size: 16
              }) : /*#__PURE__*/React.createElement(Icon, {
                className: "Button-icon",
                color: color,
                icon: icon,
                size: sizeValue === 'jumbo' ? 16 : 12
              })), pending && /*#__PURE__*/React.createElement(Box, {
                padding: getIconPadding(iconPosition, isLabelVisible, sizeValue)
              }, /*#__PURE__*/React.createElement(Spinner, {
                color: getSpinnerColor(color),
                flex: true,
                size: sizeValue === 'jumbo' ? 'medium' : 'small'
              })), label && /*#__PURE__*/React.createElement(Text, _extends({}, labelProps, {
                className: "Button-label",
                color: color,
                visuallyHidden: hideLabel,
                wrap: false
              }), label)));
            }));
          });
        });
      });
    }
  }]);

  return Button;
}(React.Component);

Button.defaultProps = {
  alignContents: true,
  color: 'white',
  disabledWhenPending: true,
  radius: 'all',
  size: 'medium',
  type: 'button'
};
export default Button;